import { CircularProgress } from '@material-ui/core/';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Moment from 'moment';
import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from '../../axios-default';
import '../../util/string';
import SideNav from '../../components/Admin/SideNav';

const title = 'Slow Moving Cases';

const CaseStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            background: '#fdfdfd',
        },
    },
    root: {
        flexGrow: 1,
    },
    rootContainer: {
        padding: 16,
        margin: '8px 0px 0px 238px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '12px 0px 0px 0px',
            width: '100%',
        },
        width: 'calc(100% - 238px)',
    },
    scanBox: {
        padding: 16,
        margin: '8px 0px',
    },
    textField: {
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
    },
    dateField: {
        width: '100%',
    },
    formControl: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
        marginLeft: 0,
    },
    submitBtn: {
        backgroundColor: '#061a2e !important',
        color: 'white',

        padding: '8px 24px',
        margin: '12px 0px',
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
    },
}));

let columns = [
    {
        name: 'case_id',
        label: 'Case ID',
    },
    {
        name: 'case_type',
        label: 'TP Option',
    },
    {
        name: 'case_status',
        label: 'Current Status',
    },
    {
        name: 'updated_date',
        label: 'Updated Date',
    },
    {
        name: 'no_update',
        label: 'No Update',
    },
    {
        name: 'ref_code',
        label: 'Case Ref#',
    },
    {
        name: 'created_by',
        label: 'DR ID#',
    },
    {
        name: 'archived',
        label: 'Archived',
    },
];

if (['SADMIN', 'ADMIN'].includes(JSON.parse(localStorage.getItem('role')))) {
    columns.unshift({
        name: 'distr_group_name',
        label: 'Distr Group',
    });
}

const options = {
    filter: true,
    selectableRows: 'none', // You can change this based on your needs
    viewColumns: false,
    responsive: 'vertical',
    rowsPerPage: 50,
    rowsPerPageOptions: [25, 50, 100],
    minHeight: '300px', // Set the minimum body height
    maxHeight: '10000px', // Set the maximum body height
};

const SlowMovingCases = () => {
    const classes = CaseStyles();
    const history = useHistory();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData({ pageSize: 10, page: 0 });
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.get(`/case/slow_moving_cases`);

            const responseData = response.data;

            const formattedData = responseData.case.map((c) => {
                const formattedObject = {};
                columns.forEach((column) => {
                    if (column.name === 'updated_date') {
                        formattedObject[column.name] = Moment(c[column.name]).format('YYYY-MM-DD ddd hh:mm A');
                    } else {
                        formattedObject[column.name] = c[column.name];
                    }
                });
                return formattedObject;
            });

            setData(formattedData);
            setLoading(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.replace('/login');
            }
        }
    };

    return (
        <div>
            <SideNav />
            <Grid container className={classes.rootContainer}></Grid>
            <Grid container className={classes.rootContainer} style={{ marginTop: 0 }}>
                {!loading ? (
                    <div style={{ display: 'contents' }}>
                        <Grid container>
                            <Grid item xs={12} style={{ padding: 8 }}>
                                <h1 style={{ marginBlockEnd: 0 }}>{title}</h1>
                                <hr />
                            </Grid>

                            <Grid xs={12} style={{ padding: 8 }}>
                                <MUIDataTable
                                    data={data}
                                    columns={columns}
                                    options={options}
                                    minBodyHeigh={700}
                                    maxBodyHeight={1000}
                                />
                            </Grid>
                        </Grid>
                    </div>
                ) : (
                    <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress style={{ color: 'rgb(6,26,46)' }} />
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

export default SlowMovingCases;
